import { render } from "./alarmAddressComment.vue?vue&type=template&id=d4ca295c"
import script from "./alarmAddressComment.vue?vue&type=script&lang=js"
export * from "./alarmAddressComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__